import { User as FirebaseUser } from 'firebase/auth';

export enum AuthFlowType {
  SIGNIN = 'signin',
  COMPLETEPASSWORD = 'complete-password',
  CHANGEPASSWORD = 'change-password',
  RESETPASSWORD = 'reset-password',
  AUTHENTICATED = 'authenticated',
}

export enum AuthErrorMessages {
  TOKEN_ERROR = 'Authentication could not be completed, please contact an administrator.',
  USER_RETRIEVAL_ERROR = 'User data could not be retrieved correctly, please contact an administrator.',
  INVALID_INPUT = 'The form contains errors.',
  INVALID_CREDENTIALS = 'Username/password does not match, please try again.',
}

export type SignupConfig = {
  username: string;
  password: string;
};

export type AuthState = {
  signup: (config: SignupConfig) => Promise<void>;
  signin: (username: string, password: string) => Promise<void>;
  signout: () => Promise<void>;
  changePassword: (oldPassword: string, newPassword: string) => Promise<void>;
  error?: string;
  user: {
    current: FirebaseUser | null;
    refresh: (forceRefresh: boolean) => void;
  };
};
